import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppProviders } from './contexts';
import { ErrorBoundary } from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppProviders>
        <App />
      </AppProviders>
    </ErrorBoundary>
  </React.StrictMode>
);

// Register service worker for offline support
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('[Atlas IDE] Service worker registered successfully');
  },
  onUpdate: (registration) => {
    console.log('[Atlas IDE] New content available, please refresh');
    // Show update notification to user
    const event = new CustomEvent('sw-update-available', { detail: registration });
    window.dispatchEvent(event);
  },
  onOffline: () => {
    console.log('[Atlas IDE] Running in offline mode');
    const event = new CustomEvent('sw-offline');
    window.dispatchEvent(event);
  },
  onOnline: () => {
    console.log('[Atlas IDE] Back online');
    const event = new CustomEvent('sw-online');
    window.dispatchEvent(event);
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
